import script from "./ClassPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassPopUp.vue?vue&type=script&setup=true&lang=js"

import "./ClassPopUp.vue?vue&type=style&index=0&id=8974680e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8974680e"]])

export default __exports__